import useApiServices from './useApiServices';
import { globalAdminUrl } from './globalApi';
//
/**
 * @module AdminServiceService
 * @returns  it return All DataSource Apis
 */

const RevenueService = {
  // add ne revenue file
  AddNewFile: (credential, token) =>
    useApiServices().postApi(`${globalAdminUrl}/revenue/add-update-file`, credential, token),

  RevenueListData: (credential, token) =>
    useApiServices().postApi(`${globalAdminUrl}/revenue/list`, credential, token),

  RevenueViewFile: (credential, token) =>
    useApiServices().postApi(`${globalAdminUrl}/revenue/view-file`, credential, token),

  DownloadMisDetails: (credential, token) =>
    useApiServices().postApiBlob(
      `${globalAdminUrl}/revenue/download-mis-details`,
      credential,
      token
    ),
  DownloadDataValidateRecord: (credential, token) =>
    useApiServices().postApiBlob(`${globalAdminUrl}/data-source/download`, credential, token),

  DownloadExportRecord: (credential, token) =>
    useApiServices().postApiBlob(`${globalAdminUrl}/data-source/export`, credential, token),

  DownloadUserRecord: (credential, token) =>
    useApiServices().postApiBlob(`${globalAdminUrl}/v1/download-user-reports`, credential, token),

  DownloadIncentiveTemplate: (path, crd, token) =>
    useApiServices().getApiBlob(
      `${globalAdminUrl}/incentives/template?incentiveType=${path?.incentiveType}`,
      token
    ),
  DownloadCustomerRecord: (endpoint, credential, token) =>
    useApiServices().postApiBlob(`${globalAdminUrl}/${endpoint}`, credential, token),

  DownloadBankopsRecord: (credential, token) =>
    useApiServices().postApiBlob(
      `${globalAdminUrl}/bankOps/downloadBankOpsData`,
      credential,
      token
    ),

  UploadMisFile: () => `${globalAdminUrl}/revenue/upload-mis-file`,

  UploadRevenueFile: () => `${globalAdminUrl}/revenue/v1/uploads`,

  DownloadMisTemplate: (token) =>
    useApiServices().getApiBlob(`${globalAdminUrl}/revenue/download-mis-template`, token),

  DownloadPayoutTemplate: (token) =>
    useApiServices().getApiBlob(`${globalAdminUrl}/payout/template`, token),

  AddComment: (credential, token) =>
    useApiServices().postApi(`${globalAdminUrl}/revenue/add-comment`, credential, token),

  UpdateStatus: (credential, token) =>
    useApiServices().postApi(`${globalAdminUrl}/revenue/v1/update/status`, credential, token),

  CommentLogs: (id, token) =>
    useApiServices().getApi(`${globalAdminUrl}/revenue/list/comment-logs/${id}`, token),

  ListPartnerDetail: (token) =>
    useApiServices().getApi(`${globalAdminUrl}/revenue/list/partner-detail`, token),

  EditPartnerDetail: (credential, token) =>
    useApiServices().postApi(`${globalAdminUrl}/revenue/edit/partner-detail`, credential, token),

  CheckPartnerExist: (id, id1, token) =>
    useApiServices().getApi(`${globalAdminUrl}/revenue/check-partner-exist/${id}/${id1}`, token)
};

export default RevenueService;
